<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch,computed } from 'vue'
import ModalDialog from "../../compositions/ModalDialog.vue";
import SelectBox from "../../compositions/SelectBox.vue";
import TextBox from "../../compositions/TextBox.vue";
import CheckBox from "../../compositions/CheckBox.vue";
import { errorAlert,confirmAlert } from "../../plugins/alert";
import MedicineHistoryDetailComponent from "./MedicineHistoryDetailComponent.vue";
import MedicineHistoryListComponent from "./MedicineHistoryListComponent.vue";
import PrescriptAnalyzeListComponent from "./PrescriptAnalyzeListComponent.vue";
import CustomEvent from "../../compositions/CustomEvent.vue";
import qs from 'qs';
import axios from '../../plugins/axios.ts';
import moment from "moment";

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    yjCode:{
      type:String,
      default:() => {
        return '';
      },
    },
    pharmacyWholesalers:{
      type:Array,
      required:true,
    },
    cancel:{
      type:Function,
      required:true,
    },
    identityId:{
      type:Number,
      default:() => {
        return 0;
      },
    },
    isMedicineFix:{
      type:Boolean,
      default:() => {
        return false;
      },
    },
    isStockControl:{
      type:Boolean,
      default:() => {
        return false;
      },
    },
    isSelf:{
      type:Boolean,
      default:() => {
        return false;
      },
    },
    isDeletable:{
      type:Boolean,
      default:() => {
        return false;
      },
    },
    updateComplete:{
      type:Function,
      required:true,
    },
    sameCode:{
        type:String,
        default: () => {
            return '';
        }
    },
})

const medicineYjCode = ref(props.yjCode);
const { yjCode,identityId,sameCode } = toRefs(props);
const medicineSameCode = ref(props.sameCode);
const inputRefs = ref();
const isLoadingDialog = ref(false);
const pharmacyMedicineName = ref('');
const pharmacyMedicineWarningMark = ref('');
const pharmacyMedicineList = reactive([]);
const onSelectChangeMedicine = (value,label) => {
  medicineYjCode.value = value;
  pharmacyMedicineName.value = label;
  getPharmacyMedicine();
}
const checkBoxHandler = (value,valueOptions) => {
  for (let i=0;i<pharmacyMedicineList.length;i++) {
    if (pharmacyMedicineList[i].id == valueOptions['id']) {
      pharmacyMedicineList[i].selected = value;
      break;
    }
  }
}
const selectBoxHandler = (value,label,valueOptions) => {
  for (let i=0;i<pharmacyMedicineList.length;i++) {
    if (pharmacyMedicineList[i].id == valueOptions['id']) {
      if (valueOptions.type == 'wholesaler') {
        if (valueOptions.index == 0) {
          //先頭のもののみ設定するようにする（その他はリスト表示用なので）
          pharmacyMedicineList[i].wholesaler_id = value;
          pharmacyMedicineList[i].wholesaler_name = label;
        }
        if (pharmacyMedicineList[i].wholesalers.length > valueOptions.index) {
          pharmacyMedicineList[i].wholesalers[valueOptions.index] = value;
        } else {
          pharmacyMedicineList[i].wholesalers.push(value);
        }
      } else {
        pharmacyMedicineList[i].medicine_predict_id = value;
        pharmacyMedicineList[i].medicine_predict_name = label;
      }
      break;
    }
  }
}
const onChangeStorage = (value,option) => {
  for (let i=0;i<pharmacyMedicineList.length;i++) {
    if (pharmacyMedicineList[i].id == option['id']) {
      pharmacyMedicineList[i][option['field']] = value;
    }
  }
}
const textChange = (value,valueOptions) => {
  for (let i=0;i<pharmacyMedicineList.length;i++) {
    if (pharmacyMedicineList[i].id == valueOptions['id']) {
      pharmacyMedicineList[i].reference_unit_price = value;
      break;
    }
  }
}

const getPharmacyMedicine = async () => {
  pharmacyMedicineList.splice(0);
  pharmacyMedicineName.value = "";
  pharmacyMedicineWarningMark.value = "";
  optionDataList.splice(0);
  optionParentDataList.splice(0);
  initStockMode();
  if (!medicineYjCode.value) {
    return;
  }
  isLoadingDialog.value = true;
  let params = {
    yj_code:medicineYjCode.value,
    relation_pharmacy:1,
    is_stock:1,
    page_size:1000
  };
  const paramsSerializer = (params) => qs.stringify(params);
  try {
    const response = await axios.get(props.apis.medicine_list,{params:params,paramsSerializer});
    if (response.status == 200) {
      for (let i=0;i<response.data.list.length;i++) {
        if (i==0) {
          pharmacyMedicineName.value = response.data.list[i].product_name;
          pharmacyMedicineWarningMark.value = response.data.list[i].warning_mark;
        }
        pharmacyMedicineList.push(response.data.list[i]);
      }
      if (props.isSelf) {
        await getOptionData();
      }
    }
  } catch(e) {
    isLoadingDialog.value = false;
    errorAlert(e)
  } finally {
    isLoadingDialog.value = false;
  }
}
const updatePharmacyMedicineStock = async () => {
  if (props.isStockControl && editStockList.length > 0) {
      let result = await confirmAlert('<span style="color:red;">納品されたのにまだ納品確定を行っていない状態で在庫調整を行ってしまうと、在庫のズレが生じます。まだ納品確定を行っていない場合は、納品確定を行ってから在庫調整を行ってください。</span><br><br>在庫調整を行いますか？');
      if (result.isConfirmed == false) {
        return;
      }
  }
  let errorMessage = '';
  for (let i=0;i<pharmacyMedicineList.length;i++) {
    if (pharmacyMedicineList[i].selected) {
      for (let j=0;j<pharmacyMedicineList[i].wholesalers.length;j++) {
        if (pharmacyMedicineList[i].wholesalers[j] == 0) {
          errorMessage = '取引卸を設定してください。';
          break;
        }
      }
    }
    if (errorMessage.length > 0) {
      break;
    }
  }
  if (errorMessage.length > 0) {
    errorAlert(errorMessage);
    return;
  }
  let stockParams = [];
  if (props.isStockControl && editStockList.length > 0) {
    let errorFlg = false;
    for (let i=0;i<editStockList.length;i++) {
      if (editStockList[i].stock_datetime.length == 0) {
        errorFlg = true;
        break;
      }
      stockParams.push({
        medicine_id:editStockList[i].medicine_id,
        stock_number:editStockList[i].stock_number,
        update_stock_date:editStockList[i].stock_datetime
      });
    }
    if (errorFlg) {
        errorAlert('日時を入力してください。');
        return;
    }
  }
  isLoadingDialog.value = true;
  let params = [];
  for (let i=0;i<pharmacyMedicineList.length;i++) {
    params.push({
      medicine_id:pharmacyMedicineList[i].id,
      wholesalers:pharmacyMedicineList[i].wholesalers,
      medicine_predict_id:pharmacyMedicineList[i].medicine_predict_id,
      reference_unit_price:0, // 20241022 未使用に仕様変更
      storage_bin1:pharmacyMedicineList[i].storage_bin1,
      storage_bin2:pharmacyMedicineList[i].storage_bin2,
      storage_bin3:pharmacyMedicineList[i].storage_bin3,
      selected:pharmacyMedicineList[i].selected,
      is_self:props.isSelf,
      is_replace:(props.sameCode ? 1 : null),
      same_code:props.sameCode,
      is_deletable:props.isDeletable,
    });
  }
  try {
    const responsePharmacyMedicine = await axios(props.apis.pharmacy_medicine_update,{method:"post",data:params});
    if (responsePharmacyMedicine.data.status == 200) {
      if (props.isStockControl && editStockList.length > 0) {
        const responsePharmacyStock = await axios(props.apis.pharmacy_stock_update,{method:"post",data:stockParams});
        if (responsePharmacyStock.data.status == 200) {
          if (typeof props.updateComplete !== 'undefined') {
            props.updateComplete(responsePharmacyMedicine.data.data);
          }
        }
      } else {
        if (typeof props.updateComplete !== 'undefined') {
          props.updateComplete(responsePharmacyMedicine.data.data);
        }
      }
    }
  } finally {
    isLoadingDialog.value = false;
  }
}

watch(yjCode,(newValue, oldValue) => {
  if (newValue != medicineYjCode.value) {
    medicineYjCode.value = newValue;
    getPharmacyMedicine();
  }
})
watch(identityId,(newValue, oldValue) => {
  medicineYjCode.value = '';
  getPharmacyMedicine();
})
watch(sameCode,(newValue,oldValue) => {
  medicineSameCode.value = newValue;
})
onMounted(() => {
  getPharmacyMedicine();
});

const selectOrgMedicineOptions = computed(() => {
  let result = [];
  return result;
});
const selectMedicinePredictOptions = computed(() => {
  return (pharmacyMedicineId) => {
    let result = [];
    result.push({id:0,product_detail_name:'　'});
    for (let i=0;i<pharmacyMedicineList.length;i++) {
      if (pharmacyMedicineList[i].id == pharmacyMedicineId) {
        if (pharmacyMedicineList[i].medicine_predict_id > 0) {
          result.push({id:pharmacyMedicineList[i].medicine_predict_id,product_detail_name:pharmacyMedicineList[i].medicine_predict_detail_name});
        }
        break;
      }
    }
    return result;
  }
});
const selectWholesalerList = computed(() => {
  return (pharmacyMedicineId) => {
    let result = [];
    for (let i=0;i<pharmacyMedicineList.length;i++) {
      if (pharmacyMedicineList[i].id == pharmacyMedicineId) {
        result = pharmacyMedicineList[i].wholesalers;
        break;
      }
    }
    return result;
  }
});
const selectWholesalerValue = computed(() => {
  return (pharmacyMedicineId,index) => {
    let result = 0;
    for (let i=0;i<pharmacyMedicineList.length;i++) {
      if (pharmacyMedicineList[i].id == pharmacyMedicineId) {
        if (pharmacyMedicineList[i].wholesalers.length > index) {
          result = pharmacyMedicineList[i].wholesalers[index];
        }
        break;
      }
    }
    return result;
  }
});
const inputStorageBin = computed(() => {
  return (pharmacyMedicineId,field) => {
    let result = '';
    for (let i=0;i<pharmacyMedicineList.length;i++) {
      if (pharmacyMedicineList[i].id == pharmacyMedicineId) {
        result = pharmacyMedicineList[i][field];
        break;
      }
    }
    return result;
  }
})

const isMedicineHistoryDialog = ref(false);
const showMedicineHistoryDialog = () => {
  isMedicineHistoryDialog.value = true;
}
const closeMedicineHistoryDialog = () => {
  isMedicineHistoryDialog.value = false;
}
const isMedicineDetailDialog = ref(false);
const showMedicineDetailDialog = () => {
  isMedicineDetailDialog.value = true;
}
const closeMedicineDetailDialog = () => {
  isMedicineDetailDialog.value = false;
}
const hoverPrescriptIdentityId = ref(0);
const isHoverPrescripFlg = ref(false);
const leavePrescript = () => {
  isHoverPrescripFlg.value = false;
}
const showHoverPrescript = () => {
  isClosing.value = true;
  hoverPrescriptIdentityId.value++;
  isHoverPrescripFlg.value = !isHoverPrescripFlg.value;
}
const {element,isClosing,clickOutside} = CustomEvent(leavePrescript)
onMounted(() => {
  window.addEventListener('click', clickOutside);
});
onBeforeUnmount(() => {
  window.removeEventListener('click', clickOutside);
});
///////////// 追加情報
const optionDataList = reactive([]);
const optionParentDataList = reactive([]);
const getOptionData = async () => {
  optionDataList.splice(0);
  optionParentDataList.splice(0);
  if (!medicineYjCode.value) {
    return;
  }
  let params = {
    yj_code:medicineYjCode.value,
    is_auto_view:1,
  };
  const paramsSerializer = (params) => qs.stringify(params);
  try {
    const response = await axios.get(props.apis.pharmacy_order_list,{params:params,paramsSerializer});
    if (response.status == 200) {
      if (response.data.list.length > 0) {
        optionParentDataList.push(response.data.list[0]);
        for (let i=0;i<response.data.list[0].pharmacy_medicine_list.length;i++) {
          optionDataList.push(response.data.list[0].pharmacy_medicine_list[i]);
        }
      } else {
        //採用品ではない
        optionParentDataList.push({
          prescript_predict_quantity_number:0,
          unexpected_prescript_number:0,
          expected_prescript_number:0,
          ordered_number:0,
          package_unit:pharmacyMedicineList[0].package_unit,
          carry_over_number:0,
          is_max_number_days_alert:false,
        });
        optionDataList.push({
          id:(pharmacyMedicineList.length > 0 ? pharmacyMedicineList[0].id : 0),
          product_detail_name:(pharmacyMedicineList.length > 0 ? pharmacyMedicineList[0].product_name : ''),
          warning_mark:(pharmacyMedicineList.length > 0 ? pharmacyMedicineList[0].warning_mark : ''),
          package_unit:(pharmacyMedicineList.length > 0 ? pharmacyMedicineList[0].package_unit : ''),
          stock_number:0,
          real_stock_number:0,
        });
      }
    }
  } catch(e) {
    errorAlert(e)
  } finally {
  }
}
////////////////////////////////////
////////////// 在庫調整
const editStockList = reactive([]);
const initStockMode = () => {
  editStockList.splice(0);
}
const editStockTextChange = (value,option) => {
  let exists = false;
  for (let i=0;i<editStockList.length;i++) {
    if (editStockList[i].medicine_id == option.medicine_id) {
      if (value === '') {
        editStockList.splice(i,1);
      } else {
        editStockList[i].stock_number = value;
      }
      exists = true;
      break;
    }
  }
  //空白は追加しない
  if (value === '') {
    return;
  }
  if (exists == false) {
    let today = new Date();
    editStockList.push({medicine_id:option.medicine_id,stock_number:value,stock_datetime:moment(today).format('YYYY-MM-DD HH:mm:ss')});
  }
}
const editStockDateTimeChange = (value,option) => {
  let exists = false;
  for (let i=0;i<editStockList.length;i++) {
    if (editStockList[i].medicine_id == option.medicine_id) {
      editStockList[i].stock_datetime = value;
      exists = true;
      break;
    }
  }
  if (exists == false) {
    editStockList.push({medicine_id:option.medicine_id,stock_number:'',stock_datetime:value});
  }
}

const inputStockNumber = computed(() => {
  return (medicineId) => {
    let result = '';
    for (let i=0;i<editStockList.length;i++) {
      if (editStockList[i].medicine_id == medicineId) {
        result = editStockList[i].stock_number;
        break;
      }
    }
    return result;
  };
})
const inputStockDateTime = computed(() => {
  return (medicineId) => {
    let result = '';
    for (let i=0;i<editStockList.length;i++) {
      if (editStockList[i].medicine_id == medicineId) {
        result = editStockList[i].stock_datetime;
        break;
      }
    }
    return result;
  };
})
////////////////
const totalStockNumber = computed(() => {
  let result = 0;
  for (let i=0;i<optionDataList.length;i++) {
    result += optionDataList[i].stock_number;
  }
  return result;
})
const totalRealStockNumber = computed(() => {
  let result = 0;
  for (let i=0;i<optionDataList.length;i++) {
    result += optionDataList[i].real_stock_number;
  }
  return result;
})
</script>

<style scoped>
table.option-table {
  width:100%;
  border-collapse:collapse;
}
table.option-table > thead > tr > th {
  border-bottom: 2px solid #ccc;
  border-right: 1px solid #fff;
  position:sticky;
  top:0;
  left:0;
  z-index:1;
  background-color: rgb(97, 97, 97);
  color:#fff;
  line-height: 1.4;
}
table.option-table > tbody > tr {
  border-bottom:1px solid #ccc;
}
table.option-table > tbody > tr > td {
  padding:0.5em;
  white-space: pre-wrap;
  text-align: center;
}
</style>
<template>
<div class="mb-6">
  <div class="mb-3 px-3 py-2 md:mb-0 md:rounded-t">
    <p v-if="isMedicineFix" class="text-lg font-bold">{{ pharmacyMedicineName }}</p>
    <div v-else class="">
      <select-box
        :options="selectOrgMedicineOptions"
        :on-change="onSelectChangeMedicine"
        list-field-name="product_name"
        list-field-name-option="relation_exists_message"
        list-id-name="yj_code"
        list-height="20em"
        :value="medicineYjCode"
        :api-url="apis.medicine_list"
        :api-option-fields="{grouping:1,relation_pharmacy:1,is_alive:1,is_except_relation:(isSelf == false && medicineSameCode.length == 0 ? 1 : null),same_code:medicineSameCode}"
      ></select-box>
    </div>
  </div>
  <div class="md:border p-2">
    <div v-show="(isSelf || medicineSameCode.length > 0) && pharmacyMedicineList.length > 0" class="w-full">
      <table class="option-table">
        <thead>
          <tr>
            <th>採用品</th>
            <th>実在庫数</th>
            <th>仮在庫数</th>
            <th>総実在庫数</th>
            <th>総仮在庫数</th>
            <th>予測必要数</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(optionData,optionIndex) in optionDataList" :key="optionData.id">
            <td><a href="javascript:void(0)" class="text-amber-700" @click="showMedicineDetailDialog">{{ optionData.product_detail_name }}</a><span v-html="optionData.warning_mark"></span></td>
            <td>
              <div>{{ optionData.real_stock_number.toLocaleString() + optionData.package_unit }}</div>
              <div class="flex flex-row items-center justify-center">
                <div class="mr-2"><a href="javascript:void(0)" @click="showMedicineHistoryDialog"><i class="fa-solid fa-list"></i></a></div>
                <div class="relative">
                  <a href="javascript:void(0)" class="relative cursor-default mr-2" @click="showHoverPrescript">
                    <i class="fa-solid fa-user"></i>
                  </a>
                  <div ref="element" v-show="isHoverPrescripFlg" class="absolute top-5 -left-36 w-auto" style="z-index:2">
                    <prescript-analyze-list-component
                      :apis="apis"
                      :yj-code="medicineYjCode"
                      :identity-id="hoverPrescriptIdentityId"
                    ></prescript-analyze-list-component>
                  </div>
                </div>
              </div>
            </td>
            <td><div :class="(optionData.real_stock_number != optionData.stock_number ? ' text-red-700 text-bold ' : '')">{{ optionData.stock_number.toLocaleString() + optionData.package_unit }}  <span v-show="optionData.is_max_number_days_alert" class="text-red-700 text-bold"> <i class="fa-solid fa-triangle-exclamation"></i></span></div></td>
            <td v-if="optionIndex == 0" v-for="optionParentDataListRecord in optionParentDataList" :key="optionParentDataListRecord.id" :rowspan="optionDataList.length">
              {{ totalRealStockNumber }}{{ optionParentDataListRecord.package_unit }}
            </td>
            <td v-if="optionIndex == 0" v-for="optionParentDataListRecord in optionParentDataList" :key="optionParentDataListRecord.id" :rowspan="optionDataList.length" :class="(totalRealStockNumber != totalStockNumber ? ' text-red-700 text-bold ' : '')">
              {{ totalStockNumber }}{{ optionParentDataListRecord.package_unit }}
            </td>
            <td v-if="optionIndex == 0" v-for="optionParentDataListRecord in optionParentDataList" :key="optionParentDataListRecord.id" :rowspan="optionDataList.length">
              {{ optionParentDataListRecord.prescript_predict_quantity_number.toLocaleString() + optionParentDataListRecord.package_unit }}
              <!--
              {{ optionParentDataListRecord.unexpected_prescript_number ? '(対象外:' + optionParentDataListRecord.unexpected_prescript_number.toLocaleString() + ')' : '' }}
              {{ optionParentDataListRecord.ordered_number && optionParentDataListRecord.ordered_number > 0 ? '(発注済み:' + optionParentDataListRecord.ordered_number.toLocaleString() + ')' : ''}}
              {{ optionParentDataListRecord.carry_over_number ? '(繰越:' + optionParentDataListRecord.carry_over_number.toLocaleString() + ')' : ''}}
               -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <table class="w-full">
      <thead>
        <tr>
          <th>包装</th>
          <th>{{ isStockControl == false ? '取引卸' : '取引卸/実在庫・仮在庫' }}</th>
          <th>{{ isStockControl == false ? '' : '在庫数' }}</th>
          <th>{{ isStockControl == false ? '予測切替先' : '予測切替先/在庫調整日時' }}</th>
          <th>{{ isStockControl == false ? '棚番' : '棚番' }}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="border-b border-white" v-for="(pharmacyMedicineData,index) in pharmacyMedicineList" :key="pharmacyMedicineData.id">
          <td class="block px-3 py-2 text-left md:table-cell md:text-sm">
            <check-box
              :label="(pharmacyMedicineData.transitional_measure_date ? '<span style=\'color:#f00;\'>' + (pharmacyMedicineData.package_label ? pharmacyMedicineData.package_label : '') + (pharmacyMedicineData.seller_name_omit ? '(' + pharmacyMedicineData.seller_name_omit + ')' : '') + '<br>経過措置日付:' + pharmacyMedicineData.transitional_measure_date + '</span>' : (pharmacyMedicineData.package_label ? pharmacyMedicineData.package_label : '') + (pharmacyMedicineData.seller_name_omit ? '(' + pharmacyMedicineData.seller_name_omit + ')' : ''))"
              :value="pharmacyMedicineData.selected"
              :value-options="{id:pharmacyMedicineData.id}"
              :on-change="checkBoxHandler"
            ></check-box>
          </td>
          <td class="block py-3 text-sm md:table-cell md:px-3 md:py-2">
            <div class="flex flex-row items-center mb-2" v-for="(pharmacyMedicineWholesaler,index) in selectWholesalerList(pharmacyMedicineData.id)" :key="index">
              <select-box
                :value-options="{id:pharmacyMedicineData.id,type:'wholesaler',index:index}"
                :options="pharmacyWholesalers"
                :on-change="selectBoxHandler"
                :is-hover-popup="true"
                list-field-name="wholesaler_name"
                :value="selectWholesalerValue(pharmacyMedicineData.id,index)"
                :is-searchable="false"
              ></select-box>
            </div>
            <div v-show="isStockControl" class="mb-2">実在庫：{{ (pharmacyMedicineData.real_stock_number != null ? pharmacyMedicineData.real_stock_number : 0) }}{{ pharmacyMedicineData.package_unit }}</div>
            <div v-show="isStockControl" :class="(pharmacyMedicineData.real_stock_number != pharmacyMedicineData.stock_number ? ' text-red-700 text-bold ' : '')">仮在庫：{{ (pharmacyMedicineData.real_stock_number != null ? pharmacyMedicineData.real_stock_number : 0) }}{{ pharmacyMedicineData.package_unit }}</div>
          </td>
          <td class="block py-3 text-sm md:table-cell md:px-3 md:py-2">
            <div v-show="isStockControl">
              <text-box
                ref="inputRefs"
                type="number"
                :identity-id="String(pharmacyMedicineData.id)"
                :value="inputStockNumber(pharmacyMedicineData.id)"
                :value-options="{medicine_id:pharmacyMedicineData.id}"
                :on-change="editStockTextChange"
                :is-focus-clear="true"
              ></text-box>
            </div>
          </td>
          <td class="block py-3 text-sm md:table-cell md:px-3 md:py-2">
            <div class="mb-2">
              <select-box
                :value-options="{id:pharmacyMedicineData.id,type:'medicine_predict'}"
                :options="selectMedicinePredictOptions(pharmacyMedicineData.id)"
                :on-change="selectBoxHandler"
                :is-read-only="pharmacyMedicineData.medicine_type == 0 ? false : true"
                :is-hover-popup="true"
                list-field-name="product_detail_name"
                :value="pharmacyMedicineData.medicine_predict_id"
                :api-url="apis.medicine_list"
              ></select-box>
            </div>
            <div v-show="isStockControl">
              <text-box
              ref="inputRefs"
              type="datetime-local"
              :identity-id="String(pharmacyMedicineData.id)"
              :value="inputStockDateTime(pharmacyMedicineData.id)"
              :value-options="{medicine_id:pharmacyMedicineData.id}"
              :on-change="editStockDateTimeChange"
              :is-focus-clear="false"
              ></text-box>
            </div>
          </td>
          <td class="block py-3 text-sm md:table-cell md:px-3 md:py-2">
            <div class="flex flex-row items-center">
              <div class="mr-1 w-28">
                <text-box
                  ref="inputRefs"
                  type="text"
                  :identity-id="String(pharmacyMedicineData.id)"
                  :value="inputStorageBin(pharmacyMedicineData.id,'storage_bin1')"
                  :value-options="{id:pharmacyMedicineData.id,field:'storage_bin1'}"
                  :on-change="onChangeStorage"
                  :is-focus-clear="false"
                  ></text-box>
              </div>
              <div class="mr-1 text-lg">-</div>
              <div class="mr-1 w-28">
                <text-box
                  ref="inputRefs"
                  type="text"
                  :identity-id="String(pharmacyMedicineData.id)"
                  :value="inputStorageBin(pharmacyMedicineData.id,'storage_bin2')"
                  :value-options="{id:pharmacyMedicineData.id,field:'storage_bin2'}"
                  :on-change="onChangeStorage"
                  :is-focus-clear="false"
                  ></text-box>
              </div>
              <div class="mr-1 text-lg">-</div>
              <div class="w-28">
                <text-box
                  ref="inputRefs"
                  type="text"
                  :identity-id="String(pharmacyMedicineData.id)"
                  :value="inputStorageBin(pharmacyMedicineData.id,'storage_bin3')"
                  :value-options="{id:pharmacyMedicineData.id,field:'storage_bin3'}"
                  :on-change="onChangeStorage"
                  :is-focus-clear="false"
                  ></text-box>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="flex">
    <div class="flex-row mr-2">
      <button type="button" @click="updatePharmacyMedicineStock" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">登録する</button>
    </div>
    <div class="flex-row">
      <button type="button" @click="cancel" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
    </div>
  </div>
</div>
<modal-dialog
  :is-visible="isMedicineDetailDialog"
  width="90%"
  :close="closeMedicineDetailDialog"
>
  <template v-slot:header>
    採用品在庫履歴
  </template>
  <template v-slot:default>
    <medicine-history-detail-component
      :apis="apis"
      :search-key="medicineYjCode"
    ></medicine-history-detail-component>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isMedicineHistoryDialog"
  width="90%"
  :close="closeMedicineHistoryDialog"
>
  <template v-slot:header>
    採用品受発注履歴
  </template>
  <template v-slot:default>
    <medicine-history-list-component
      :apis="apis"
      :yj-code="medicineYjCode"
      :history-medicine-name="pharmacyMedicineName"
    ></medicine-history-list-component>
  </template>
</modal-dialog>
<modal-dialog
  :is-visible="isLoadingDialog"
  width="40%"
  :isLoading="true"
>
  <template v-slot:header>
  </template>
  <template v-slot:default>
  <div class="mb-6">
    処理中です。
  </div>
  </template>
</modal-dialog>
</template>

